export const CORE_PROPERTIES_TAB_IDS = {
    PROPERTIES: "properties",
} as const;

export type CorePropertiesTabId = (typeof CORE_PROPERTIES_TAB_IDS)[keyof typeof CORE_PROPERTIES_TAB_IDS];
